const style = {
  text: {
    color: '#FFF',
    margin: 0,
  },
};

export default style;
